import { action, createReducer } from 'shared/utils/redux'
const reducerHandler = createReducer()

// ------------------------------------
// Actions
// ------------------------------------
export const actions = {
  getPageContent: action({
    type: 'common.getPageContent',
    action: (catname, http) => {
      return http.get('/cms-web-api/cms/cat/show/ztx/' + catname)
    },
    handler: (state, result) => {
      return {
        ...state,
        page: result.data.page
      }
    }
  }, reducerHandler)
}


// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {

}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  page: {}
}


export default function (state = initialState, action) {

  if (!action) {
    return state
  }

  const handler = ACTION_HANDLERS[action.type]
  let nextState =  handler ? handler(state, action) : {...state}
  nextState = reducerHandler(initialState)(nextState, action)
  return nextState
}



// WEBPACK FOOTER //
// ./components/page/pageModule.js